import i18next from 'i18next';
import i18NextHttpBackend from 'i18next-http-backend';
import languageDetector from 'i18next-browser-languagedetector';

export { i18next, i18NextHttpBackend, languageDetector };
